import { Nullable } from "@core/domain/types/nullable.type";
import { ProjectKanbanBlockDto } from "@project/data/dto/kanban/project-kanban-block.dto";
import { ProjectKanbanBlock } from "@project/domain/models/project-kanban-block.model";
import { validateSync } from "class-validator";
import { injectable } from "inversify";

@injectable()
export class ProjectKanbanBlockMapper {
    map(dto: ProjectKanbanBlockDto): Nullable<ProjectKanbanBlock> {
        const errors = validateSync(dto);
        if (errors.length) {
            console.error(errors);
            return null;
        }

        return new ProjectKanbanBlock(
            dto.id,
            dto.project,
            dto.name,
            dto.position,
            (dto.phase ?? "") as ProjectKanbanBlock["phase"],
            dto.is_active,
        );
    }
}
